import {concatWithBrandName} from "../../app/utils/concat_with_brand_name";
import {VendorType} from "../../vendor/helpers/VendorType";

export const descriptionVendorDetail = (vendorType: VendorType, vendorName: string, cityName?: string) => {
    const vendorPart = `${vendorType === VendorType.AGENCY ? "agencji nieruchomości" : "dewelopera"} ${vendorName}`;
    const inLocation = cityName ? ` w lokalizacji ${cityName}` : "";

    return `Sprawdź ofertę 🔎 ${vendorPart}${inLocation} ${concatWithBrandName("na")}. Znajdź wymarzone mieszkanie i porozmawiaj z doradcą ✅`;
};
